export default function ($location) {
    return {
        restrict: 'E',
        scope: {
            entity: '&',
            text: '=',
            id: '=',
            type: '='

        },
        link: function (scope, element) {
            if(!scope.entity())
                scope.entity = {
                    id : scope.id,
                    entity : scope.type
                };

        },
        template: '<a ui-sref="edit(entity)">{{text}}</a>'
    };
};


/** WEBPACK FOOTER **
 ** ./js/directives/entity_edit.js
 **/